export const environment = {
  production: false,
  ccitySimulateEnabled: true,
  API_BASE_URL: 'https://stageapi.pactrak.com',
  b2cRedirectURL: 'https://stage.pactrak.com/',
  MOCK_API_URL: 'https://stagepactrak.azurewebsites.net',
  B2CName:'B2C_1_stage-pactraktng',
  clientId:'03a9b2d6-99cd-44cc-9551-a2baabbfeb4e',
  B2CApiName:'stage-pactrak-api',
  azureCDNAccountsData: 'https://pactrakcdn.z13.web.core.windows.net/account-summary-help.json',
  azureCDNAdvancedSearchHelp: 'https://pactrakcdn.z13.web.core.windows.net/advanced-search-help.json',
  azureCDNUserManagementHelp: 'https://pactrakcdn.z13.web.core.windows.net/user-management-summary-help.json',
  azureCDNShortcutKeysCatalog: 'https://pactrakcdn.z13.web.core.windows.net/shortcut-keys.catalog.json',
  // Telemetry configuration
  telemetry: {
    enabled: true,
    fallbackToConsole: true,
  },
  // Roles & Permissions Enforcement configuration
  rolesPermissionsEnforcement: {
    enabled: true,
  },
  b2authority: 'https://pactrakuser.b2clogin.com/pactrakuser.onmicrosoft.com/',
  authorityDomain: 'pactrakuser.b2clogin.com',
  protectedResources: 'https://pactrakuser.onmicrosoft.com/'
};
